import type { ReactNode } from "react";

export function EmptyState({
  title = "Nothing here",
  hint,
  action,
  className = "",
}: {
  title?: ReactNode;
  hint?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex h-full min-h-24 flex-col items-center justify-center gap-1 p-4 text-center text-fg-muted ${className}`}
    >
      <div className="text-sm">{title}</div>
      {hint && <div className="max-w-md text-[11px] text-fg-faint">{hint}</div>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
